
              import { AppData } from './data.interface';

              export const appData: AppData = {
  "id": "3a218f56-3583-4cac-bc66-329fca96de36",
  "domain": "https://kktoemrer.dk",
  "design": "Bremen",
  "language": "da",
  "smileyId": "1470265",
  "systemURLs": {
    "services": "services",
    "products": "vi-leverer",
    "articles": "artikler",
    "cases": "cases",
    "contact": "kontakt",
    "about us": "om-os"
  },
  "contactFormSettings": {
    "email": "kago7400@gmail.com"
  },
  "companyDetails": {
    "name": "K+K Tømrer",
    "cvr": "44369060",
    "facebookLink": "https://www.facebook.com/www.fscbyg/",
    "linkedInLink": "",
    "youtubeLink": "",
    "instagramLink": ""
  },
  "memberOfAssociations": [],
  "products": [
    {
      "key": "product.product-1",
      "seoUrl": "toemrerarbejde-vinduer-tag-terrasser",
      "title": "Tømrerarbejde i særklasse. Fokus på vinduer, tag og terrasser - K+K Tømrer",
      "metaDescription": "Få skræddersyet tømrerarbejde til dit hjem hos Tømrerfirmaet K+K Tømrer. Vi tilbyder alt fra vinduesinstallationer og tagreparationer til terrasseopførelse med fokus på kvalitet og kundetilfredshed. Kontakt os i dag for et uforpligtende tilbud i Herning, Ikast-Brande eller Holstebro",
      "name": "Tømrerarbejde",
      "articleHeader": "Professionelt tømrerarbejde i Herning, Ikast-Brande og Holstebro",
      "summary": "Vi specialiserer os i alt fra vinduesreparationer til tagdækning til terrasser og komplekse tømrerprojekter. Med Tømrerfirmaet K+K Tømrer får du en pålidelig partner, der lytter til dine ønsker, rådgiver og leverer håndværk af højeste kvalitet til din bolig",
      "articleContent": "<p><strong>Professionelt t&oslash;mrerarbejde til private hjem</strong><br>Hos T&oslash;mrerfirmaet K+K T&oslash;mrer forst&aring;r vi, at ethvert hjem er unikt, og hver t&oslash;mreropgave kr&aelig;ver sin helt egen tilgang. Vi er stolte af at kunne tilbyde alt i t&oslash;mrerarbejde til private hjem, med s&aelig;rlig dygtighed inden for installation og reparation af vinduer, tagd&aelig;kning og opf&oslash;relse af terrasser. Vores faglige stolthed skinner igennem i hvert projekt, og vi sikrer os altid, at arbejdet udf&oslash;res korrekt og med &oslash;je for det bedste resultat.</p>\n<p>&nbsp;</p>\n<p><strong>Installation og reparation af vinduer</strong><br>N&aring;r det kommer til vinduer, tilbyder vi b&aring;de installation af nye elementer og reparation af eksisterende vinduer, uanset om de er i tr&aelig; eller plastik. Vi forst&aring;r, at vinduer ikke kun skal se godt ud, men ogs&aring; bidrage til hjemmets energieffektivitet og komfort. Vores specialister s&oslash;rger for, at dine vinduer er t&aelig;tte, funktionelle og &aelig;stetisk tiltalende, hvilket kan reducere energiforbruget og forbedre indeklimaet.</p>\n<p>&nbsp;</p>\n<p><strong>Tagd&aelig;kning og tagreparation</strong><br>Hvis dit tag tr&aelig;nger til en k&aelig;rlig h&aring;nd, er K+K T&oslash;mrer klar til at hj&aelig;lpe. Vi har ekspertisen til at h&aring;ndtere alle slags tagmaterialer - fra klassisk tegl og holdbart beton til moderne st&aring;ltag. Uanset om det drejer sig om en ny tagd&aelig;kning eller reparation af et eksisterende tag, sikrer vi, at dit hjem er beskyttet mod vejr og vind. Vores erfaring og dygtighed garanterer, at dit tag er b&aring;de holdbart og smukt, hvilket &oslash;ger boligens v&aelig;rdi og levetid.</p>\n<p>&nbsp;</p>\n<p><strong>Opf&oslash;relse af terrasser</strong><br>En terrasse er hjemmets udend&oslash;rs samlingssted, og vi skaber smukke, holdbare terrasser i b&aring;de tr&aelig; og komposit, der passer til b&aring;de private hjem og sommerhuse. Vores terrasser designes for at give dig det bedste udend&oslash;rs milj&oslash;, hvor familie og venner kan samles og nyde livet. Vi fokuserer p&aring; at kombinere funktionalitet og &aelig;stetik, s&aring; din terrasse bliver et naturligt og indbydende udvidelse af dit hjem.</p>\n<p>&nbsp;</p>\n<p><strong>R&aring;dgivning og dialog</strong><br>Vi placerer en stor v&aelig;rdi p&aring; r&aring;dgivning og dialog med dig som kunde, f&oslash;r vi frems&aelig;tter et tilbud. Det sikrer, at vi forst&aring;r dine behov og &oslash;nsker, og at du f&aring;r pr&aelig;cis det, du forventer. Vores arbejde udf&oslash;res med b&aring;de kreativitet og fleksibilitet, fordi vi ved, at ingen to opgaver er ens. Vi tager os tid til at lytte og tilbyde l&oslash;sninger, der er skr&aelig;ddersyet til din situation, hvilket sikrer et tilfredsstillende resultat hver gang.</p>\n<p>&nbsp;</p>\n<p><strong>Udf&oslash;rsel af alle typer for t&oslash;mrerarbejde</strong><br>T&oslash;mrerarbejde d&aelig;kker over en bred vifte af opgaver, der alle har det til f&aelig;lles, at de kr&aelig;ver pr&aelig;cision, dygtighed og en k&aelig;rlighed til h&aring;ndv&aelig;rket. Fra opf&oslash;relse og renovering af bygninger til finere snedkerarbejde som m&oslash;belproduktion og specialtilpasninger, er t&oslash;mrerfaget en central del af b&aring;de nybyggeri og vedligeholdelse af eksisterende strukturer.</p>\n<p>&nbsp;</p>\n<p>En dygtig t&oslash;mrer kan transformere en bolig ved at tilf&oslash;je funktionelle og &aelig;stetiske elementer, s&aring;som d&oslash;re, vinduer, gulve, lofter, k&oslash;kkener og meget mere. Uanset om det handler om store byggeprojekter som at opf&oslash;re en ny tilbygning, eller mindre, men lige s&aring; vigtige opgaver som reparation af en d&oslash;rkarm, spiller t&oslash;mreren en afg&oslash;rende rolle i at sikre kvalitet og holdbarhed.</p>\n<p>&nbsp;</p>\n<p>Med en grundig forst&aring;else af materialer, byggeteknikker og designprincipper kan en t&oslash;mrer ikke kun skabe praktiske l&oslash;sninger, men ogs&aring; bidrage til at forbedre hjemmets v&aelig;rdi og komfort.</p>\n<p>&nbsp;</p>\n<p>Hos T&oslash;mrerfirmaet K+K T&oslash;mrer er vi stolte af at levere t&oslash;mrerarbejde af h&oslash;jeste kvalitet, der im&oslash;dekommer vores kunders individuelle behov og &oslash;nsker.</p>\n<p>&nbsp;</p>\n<p><strong>Kontakt os for et uforpligtende tilbud</strong><br>Er du bosat i Herning, Ikast-Brande eller Holstebro kommuner? Kontakt os for en uforpligtende samtale, hvor vi kan diskutere dine t&oslash;mrerbehov og finde den bedste l&oslash;sning for dig. Ring til os eller send en e-mail for at f&aring; mere information og et tilbud, der er skr&aelig;ddersyet til dine pr&aelig;cise &oslash;nsker og krav. Med K+K T&oslash;mrer er dit hjem i de bedste h&aelig;nder.</p>\n<p>&nbsp;</p>\n<p>Vi forst&aring;r, hvor vigtigt det er at have et hjem, der opfylder dine dr&oslash;mme og behov. Derfor er vi dedikerede til at levere t&oslash;mrerarbejde af h&oslash;jeste kvalitet, fra det mindste projekt til de mest omfattende renoveringer. Vores m&aring;l er at overg&aring; dine forventninger og skabe resultater, du kan v&aelig;re stolt af.</p>\n<p>&nbsp;</p>\n<p>Tag f&oslash;rste skridt mod dit n&aelig;ste t&oslash;mrerprojekt ved at kontakte os i dag. Vi ser frem til at hj&aelig;lpe dig med at realisere dine boligdr&oslash;mme med professionelt og p&aring;lideligt t&oslash;mrerarbejde.</p>",
      "teaserHeader": "Professionelt Tømrerarbejde - vinduer, tag og terrasser af høj kvalitet",
      "teaserContent": "Få skræddersyet tømrerarbejde til dit hjem hos Tømrerfirmaet K+K Tømrer. Vi tilbyder alt i tømrerarbejde fra vinduesinstallationer og tagreparationer til terrasseopførelse og meget mere. Altid med fokus på kvalitet og kundetilfredshed. Klik og læs mere og få et tilbud i dag",
      "assets": [
        {
          "link": "/assets/b62cf30b-2c11-4969-989d-57070dcb7215-1000.webp",
          "alt": "Tømrer går på tagstillads",
          "id": "b62cf30b-2c11-4969-989d-57070dcb7215",
          "type": "image",
          "smallLink": "/assets/b62cf30b-2c11-4969-989d-57070dcb7215-500.webp",
          "largeLink": "/assets/b62cf30b-2c11-4969-989d-57070dcb7215-1500.webp"
        },
        {
          "link": "/assets/66e579ff-ddb0-4f04-aad9-6766ecb55fcf-1000.webp",
          "alt": "Tømrer justerer montering af nyt vindue",
          "id": "66e579ff-ddb0-4f04-aad9-6766ecb55fcf",
          "type": "image",
          "smallLink": "/assets/66e579ff-ddb0-4f04-aad9-6766ecb55fcf-500.webp",
          "largeLink": "/assets/66e579ff-ddb0-4f04-aad9-6766ecb55fcf-1500.webp"
        },
        {
          "link": "/assets/4a052b25-7161-4dff-9e31-be064b453de2-1000.webp",
          "alt": "Tømrer igang med at lægge terrasse",
          "id": "4a052b25-7161-4dff-9e31-be064b453de2",
          "type": "image",
          "smallLink": "/assets/4a052b25-7161-4dff-9e31-be064b453de2-500.webp",
          "largeLink": "/assets/4a052b25-7161-4dff-9e31-be064b453de2-1500.webp"
        },
        {
          "link": "/assets/d90d342c-a6d9-47c6-b62f-82517cfdbd41-1000.webp",
          "alt": "Stor vinduesmontage i nyt hus endegavl",
          "id": "d90d342c-a6d9-47c6-b62f-82517cfdbd41",
          "type": "image",
          "smallLink": "/assets/d90d342c-a6d9-47c6-b62f-82517cfdbd41-500.webp",
          "largeLink": "/assets/d90d342c-a6d9-47c6-b62f-82517cfdbd41-1500.webp"
        },
        {
          "link": "/assets/3e71a187-f55c-469d-92dd-60fce5445438-1000.webp",
          "alt": "Tømrer tager en pause i værkstedet",
          "id": "3e71a187-f55c-469d-92dd-60fce5445438",
          "type": "image",
          "smallLink": "/assets/3e71a187-f55c-469d-92dd-60fce5445438-500.webp",
          "largeLink": "/assets/3e71a187-f55c-469d-92dd-60fce5445438-1500.webp"
        },
        {
          "link": "/assets/3451aaf7-ada3-487c-9cee-538b427021fe-1000.webp",
          "alt": "Kran løfter tegl til tømrer der står på taget",
          "id": "3451aaf7-ada3-487c-9cee-538b427021fe",
          "type": "image",
          "smallLink": "/assets/3451aaf7-ada3-487c-9cee-538b427021fe-500.webp",
          "largeLink": "/assets/3451aaf7-ada3-487c-9cee-538b427021fe-1500.webp"
        },
        {
          "alt": "Tømrer inspicerer tagkonstruktion ",
          "link": "/assets/6300a758-4881-4695-a78f-15fb567b555d-1000.webp",
          "id": "6300a758-4881-4695-a78f-15fb567b555d",
          "type": "image",
          "smallLink": "/assets/6300a758-4881-4695-a78f-15fb567b555d-500.webp",
          "largeLink": "/assets/6300a758-4881-4695-a78f-15fb567b555d-1500.webp"
        },
        {
          "link": "/assets/0e88f496-e7ee-4e71-83b3-e7623ba4e902-1000.webp",
          "alt": "Nyanlægt terrasse inspiceres af kunde",
          "id": "0e88f496-e7ee-4e71-83b3-e7623ba4e902",
          "type": "image",
          "smallLink": "/assets/0e88f496-e7ee-4e71-83b3-e7623ba4e902-500.webp",
          "largeLink": "/assets/0e88f496-e7ee-4e71-83b3-e7623ba4e902-1500.webp"
        },
        {
          "alt": "Nyt stor vindue monteres",
          "link": "/assets/739819d2-cd8d-4de5-bdac-bcf715815f5a-1000.webp",
          "id": "739819d2-cd8d-4de5-bdac-bcf715815f5a",
          "type": "image",
          "smallLink": "/assets/739819d2-cd8d-4de5-bdac-bcf715815f5a-500.webp",
          "largeLink": "/assets/739819d2-cd8d-4de5-bdac-bcf715815f5a-1500.webp"
        },
        {
          "alt": "Tømrer monterer reglar på tagkonstruktion",
          "link": "/assets/8698be3b-b90a-44c6-949e-f7cd7d91cf36-1000.webp",
          "id": "8698be3b-b90a-44c6-949e-f7cd7d91cf36",
          "type": "image",
          "smallLink": "/assets/8698be3b-b90a-44c6-949e-f7cd7d91cf36-500.webp",
          "largeLink": "/assets/8698be3b-b90a-44c6-949e-f7cd7d91cf36-1500.webp"
        },
        {
          "link": "/assets/883e4077-6236-4763-8293-42e02e46fcd7-1000.webp",
          "alt": "Eksempel på træterrasse i lejlighed",
          "id": "883e4077-6236-4763-8293-42e02e46fcd7",
          "type": "image",
          "smallLink": "/assets/883e4077-6236-4763-8293-42e02e46fcd7-500.webp",
          "largeLink": "/assets/883e4077-6236-4763-8293-42e02e46fcd7-1500.webp"
        },
        {
          "alt": "Nyt vindue monteres af to tømrersevnde",
          "link": "/assets/8ff576cb-2b09-4bdd-b28d-6bc297e10996-1000.webp",
          "id": "8ff576cb-2b09-4bdd-b28d-6bc297e10996",
          "type": "image",
          "smallLink": "/assets/8ff576cb-2b09-4bdd-b28d-6bc297e10996-500.webp",
          "largeLink": "/assets/8ff576cb-2b09-4bdd-b28d-6bc297e10996-1500.webp"
        },
        {
          "alt": "Komplet renovering af tagsektion",
          "link": "/assets/f7ec915a-b6c8-4b84-a157-02a2393fa420-1000.webp",
          "id": "f7ec915a-b6c8-4b84-a157-02a2393fa420",
          "type": "image",
          "smallLink": "/assets/f7ec915a-b6c8-4b84-a157-02a2393fa420-500.webp",
          "largeLink": "/assets/f7ec915a-b6c8-4b84-a157-02a2393fa420-1500.webp"
        }
      ],
      "highlighted": true,
      "links": [],
      "relatedProducts": [],
      "relatedServices": [],
      "relatedCases": [],
      "relatedArticles": []
    }
  ],
  "services": [],
  "articles": [],
  "cases": [],
  "persons": [],
  "contacts": [
    {
      "title": "K+K Tømrer",
      "address1": "Jasminvej 11",
      "postalCode": "7400",
      "city": "Herning",
      "email": "kago7400@gmail.com",
      "telephone": [
        {
          "phone": "55255510",
          "id": "71627b67-5043-4c4e-8319-8bd523e5eef2",
          "title": "Kacper Otreba"
        }
      ],
      "openingHours": [
        {
          "from": "8",
          "to": "16",
          "id": "5ffa58c7-bd3a-4279-9e45-b9681f50724c",
          "title": "Mandag - fredag"
        }
      ],
      "images": [
        {
          "id": "d096b806-0f45-470d-a060-8321ee8d4202",
          "alt": "Klargøring af vindue før montering",
          "smallLink": "/assets/d096b806-0f45-470d-a060-8321ee8d4202-500.webp",
          "link": "/assets/d096b806-0f45-470d-a060-8321ee8d4202-1000.webp",
          "largeLink": "/assets/d096b806-0f45-470d-a060-8321ee8d4202-1500.webp"
        }
      ]
    }
  ],
  "home": {
    "title": "K+K Tømrer",
    "metaDescription": "Vælg K+K Tømrer for skræddersyede løsninger i vinduer, tag og terrasser. Vi tilbyder personlig rådgivning og udfører alle opgaver med præcision og kreativitet for det bedste resultat i dit hjem.",
    "articleHeader": "Professionelt tømrerarbejde i Herning, Ikast-Brande og Holstebro – kvalitet og håndværk i særklasse",
    "summary": "Vælg K+K Tømrerfirma for skræddersyede løsninger i vinduer, tag og terrasser. Vi tilbyder personlig rådgivning og udfører alle typer af tømreropgaver med præcision og kreativitet for det bedste resultat i dit hjem.",
    "articleContent": "<p>Hos K+K T&oslash;mrer, s&aelig;tter vi en &aelig;re i at levere t&oslash;mrerarbejde af h&oslash;jeste kvalitet til private hjem i Herning, Ikast-Brande og Holstebro. Med mange &aring;rs erfaring og en passion for h&aring;ndv&aelig;rk tilbyder vi skr&aelig;ddersyede l&oslash;sninger, der opfylder dine specifikke behov. Uanset om du dr&oslash;mmer om nye vinduer, en robust tagd&aelig;kning eller en smuk terrasse, eller noget helt andet, st&aring;r vores dygtige team klar til at hj&aelig;lpe. Vi l&aelig;gger v&aelig;gt p&aring; pr&aelig;cision, &aelig;stetik og funktionalitet i hvert eneste projekt, s&aring; du kan nyde et resultat, der b&aring;de er smukt og holdbart. Kontakt os i dag for en uforpligtende samtale om dit n&aelig;ste t&oslash;mrerprojekt</p>",
    "teaserHeader": "K+K Tømrer: Mester i vinduer, tagdækning og terrasser!",
    "teaserContent": "Hos K+K Tømrer, sætter vi en ære i at levere tømrerarbejde af højeste kvalitet til private hjem i Herning, Ikast-Brande og Holstebro. Med mange års erfaring og en passion for håndværk tilbyder vi skræddersyede løsninger, der opfylder dine specifikke behov. Uanset om du drømmer om nye vinduer, en robust tagdækning eller en smuk terrasse, eller noget helt andet, står vores dygtige team klar til at hjælpe. Vi lægger vægt på præcision, æstetik og funktionalitet i hvert eneste projekt, så du kan nyde et resultat, der både er smukt og holdbart",
    "assets": [
      {
        "alt": "Tømrer i Herning tager en velfortjent pause",
        "link": "/assets/6054a36e-62a7-432c-b4f4-9868bf0b24ad-1000.webp",
        "id": "6054a36e-62a7-432c-b4f4-9868bf0b24ad",
        "type": "image",
        "smallLink": "/assets/6054a36e-62a7-432c-b4f4-9868bf0b24ad-500.webp",
        "largeLink": "/assets/6054a36e-62a7-432c-b4f4-9868bf0b24ad-1500.webp"
      }
    ]
  }
}